/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type DeleteCBQExamResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: unknown;
};

// DELETE /admin/cbq/exams/:cbqExamId
export const DeleteCBQExam = async (
  examId: string
): Promise<DeleteCBQExamResponse> => {
  try {
    const response = await axios.delete(`/admin/cbq/exams/${examId}`);
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
